import React, { useState, useEffect, useContext, useRef } from 'react';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import GenericDialogBox from '../../components/GenericDialogBox';
import InfoBox from '../../components/InfoBox';
import DataService from "../../services/data.service";
import { useTranslation } from "react-i18next";
import PermissionContext from '../../contexts/PermissionContext';
import CashAuxTable from './CashAuxTable';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import SaveIcon from '@material-ui/icons/Save';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import PrintIcon from '@material-ui/icons/Print';
import Modal from '@material-ui/core/Modal';
import ReportForm from '../../components/Report/ReportForm';
import { grey, red } from '@material-ui/core/colors';
import { alpha } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(-4),
        marginBottom: theme.spacing(1),
        overflow: 'hidden',
        backgroundColor: 'white',
        padding: theme.spacing(2),
    },
    paperHead: {
        marginTop: theme.spacing(-1),
        marginBottom: theme.spacing(2),
        overflow: 'hidden',
        backgroundColor: 'white',
        padding: theme.spacing(2),
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {

        margin: theme.spacing(3, 2, 2),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    fabLeft: {
        marginLeft: theme.spacing(0),
    },
    fab: {
        marginRight: theme.spacing(0),
    },
    fabEdit: {
        color: theme.palette.common.white,
        backgroundColor: grey[500],
        '&:hover': {
            backgroundColor: grey[600],
        },
    },
    fabDelete: {
        color: theme.palette.common.white,
        backgroundColor: red[500],
        '&:hover': {
            backgroundColor: red[600],
        },
    }
}));


const endpoint = `cash-aux/`
const DATE_FORMAT = 'yyyy-MM-dd';
const DATE_FORMAT_TZ = 'yyyy-MM-dd HH:mm:ss';
const TIME_ZONE = 'America/Argentina/Buenos_Aires';

const ReportModal = React.forwardRef((props, ref) => {
    const { handleReportFormClose, showReportForm, cashId, permission } = props;
    const classes = useStyles();
    const reportGroup = 'cashAux'

    return (
        <Modal
            className={classes.modalStyle}
            open={showReportForm}
            onClose={handleReportFormClose}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description">
            <ReportForm cashId={cashId} reportGroup={reportGroup} />
        </Modal>
    )
})


const CashForm = React.forwardRef((props, ref) => {
    const { t } = useTranslation();
    const { permission } = props;

    const { userHasPermission } = useContext(PermissionContext)

    // console.log("UHP",userHasPermission)

    let hasPerm = userHasPermission(permission, 'can_list')
    let hasAddPerm = userHasPermission(permission, 'can_post')
    let hasEditPerm = userHasPermission(permission, 'can_patch')
    let hasGetPerm = userHasPermission(permission, 'can_get')
    let hasDeletePerm = userHasPermission(permission, 'can_delete')
    // for detail form
    let hasDeleteDetailPerm = userHasPermission(`${permission}-detail`, 'can_delete')



    const [cashAuxtData, setCashAuxtData] = useState([]);
    useEffect(() => {
        getData()
    }, []);



    const [cashAuxValue, setCashAuxValue] = useState(null);
    const [cashAuxInputValue, setCashAuxInputValue] = useState("");
    const [cashNameValue, setCashNameValue] = useState("");
    const [cashUserValue, setCashUserValue] = useState("");
    const [cashDescriptionValue, setCashDescriptionValue] = useState("");
    const [cashDateCreatValue, setCashDateCreatValue] = useState("");
    const [cashDateUpdateValue, setCashDateUpdateValue] = useState("");
    const cashAuxNameRef = useRef(null);

    const [isEditing, setIsEditing] = useState(false);
    const [isAdding, setIsAdding] = useState(false);

    useEffect(() => {
        if (cashAuxValue) {
            fillInFields(cashAuxValue)
        } else {
            cleanFields()
        }
    }, [cashAuxValue]);


    useEffect(() => {
        cashAuxNameRef?.current?.focus();
    }, [isAdding, isEditing]);

    // INFO NOTIFICATION VARS
    const [infoOpen, setInfoOpen] = useState(false);
    const [infoTitle, setInfoTitle] = useState('');
    const [infoBody, setInfoBody] = useState('');
    //***********************

    //Dialog Vars
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogueTitle, setDialogueTitle] = useState('');
    const [dialogueBody, setDialogueBody] = useState('');
    //**********

    // DIALOG FUNCTIONS
    const handleDialogOk = () => {
        // console.log("OK")
        // if ok delete cashAux
        deleteData(cashAuxValue.id)
        setDialogOpen(false)
    };

    const handleDialogClose = () => {
        setDialogOpen(false)
    };

    const openDialogBox = (title, body) => {
        setDialogueTitle(title)
        setDialogueBody(body)
        setDialogOpen(true)
    };
    //*******************


    const [showReportForm, setShowReportForm] = useState(false);

    const handleReportFormClose = () => {
        setShowReportForm(false);
    };

    const handleReportFormOpen = (id) => {
        // console.log("id",typeof id)
        // let newId = typeof id === 'object' ? 0 : id
        // setidToUpdate(newId)
        setShowReportForm(true);
    };


    // Notification INFO functions
    const openNoticeBox = (title, body) => {
        setInfoTitle(title)
        setInfoBody(body)
        setInfoOpen(true)
    };

    const handleInfoClose = () => {
        setInfoOpen(false)
    };
    // *****************

    const fillInFields = (data) => {

        let dateCreated = data.date_created
        let dateUpdated = data.date_modified
        setCashNameValue(data.name)
        setCashUserValue(data.user.username)
        setCashDescriptionValue(data.description)
        setCashDateCreatValue(dateCreated)
        setCashDateUpdateValue(dateUpdated)
    }
    const cleanFields = () => {
        setCashNameValue("")
        setCashUserValue("")
        setCashDescriptionValue("")
        setCashDateCreatValue("")
        setCashDateUpdateValue("")
        setCashAuxValue(null)
    }

    const getData = () => {
        DataService.getAll(endpoint)
            .then(response => {
                // console.log("get data", response.data)
                let data = response.data[0]
                setCashAuxtData(response.data)
                // fillInFields(data)
                // setIsClosed(response.data.status == 1 ? true : false)

            })
            .catch(e => {
                console.log(e)
                if (e.response.status !== 404) {
                    openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
                } else {
                    // setData({})
                    console.log("Unexpected error: ", e)
                }

            });
    }

    const updateData = (values) => {
        DataService.update(endpoint, values)
            .then(response => {
                openNoticeBox("Notice", t("record_updated_successfully", { "table": t("cash_table_title") }))
            })
            .catch(e => {
                openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
            });
    }

    const addData = (values) => {
        DataService.create(`${endpoint}`, values)
            .then(response => {
                openNoticeBox("Notice", t("record_created_successfully", { "table": t("cash_table_title") }))
                setCashAuxtData(response.data)

            })
            .catch(e => {
                openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
            });
    }

    const deleteData = (id) => {
        var dataDelete = { 'id': id };
        DataService.delete(endpoint, dataDelete)
            .then(response => {
                openNoticeBox("Notice", t("record_deleted_success"))
                cleanFields()
                setTimeout(() => {
                    getData();
                }, "1000");
            })
            .catch(e => {
                console.log("Error:", e)
                if ("Network Error" === e.message) {
                    openNoticeBox("Error Inesperado", `${e} - ` + t("error_cash_aux_with_moves"))
                } else {
                    openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText}`)
                }
            });
    }

    const handleEditing = () => {
        if (cashAuxValue) {
            setIsEditing(!isEditing)
        } else {
            openNoticeBox("Atencion", t("error_cash_aux_not_selected"))
        }
    }

    const handleAdding = () => {
        if (!cashAuxValue) {
            setIsAdding(!isAdding)
        } else {
            openNoticeBox("Atencion", t("error_cash_aux_selected"))
        }

    }

    const handleUpdating = () => {
        let values = {
            'id': cashAuxValue.id,
            'name': cashNameValue,
            'description': cashDescriptionValue,
        }
        updateData(values)
        setIsEditing(!isEditing)
        cleanFields()
        setTimeout(() => {
            getData();
        }, "1000");
    }

    const handleCreating = () => {
        let values = {
            'name': cashNameValue,
            'description': cashDescriptionValue,
        }
        addData(values)
        setIsAdding(!isAdding)
        cleanFields()
        setTimeout(() => {
            getData();
        }, "1000");
    }

    const handleDeleting = () => {
        if (!cashAuxValue) {
            openNoticeBox("Atencion", t("error_cash_aux_not_selected"))
        } else {
            openDialogBox("Atencion", t("dialog_cash_aux_delete_record", { "table": t("cash_table_title") }))
        }
    }


    const getReportData = (endpoint, payload) => {
        var varPromise = DataService.getReport2(endpoint, payload)
            .catch(e => {
                console.log(e)
                if (e.response.status !== 404) {
                    openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
                } else {
                    // setData({})
                    console.log("Unexpected error: ", e)
                }
            });
        return varPromise
    }

    const handlePrinting = () => {
        if (!cashAuxValue) {
            openNoticeBox("Atencion", t("error_cash_aux_not_selected"))
        } else {
            let values = {
                'data_from': cashAuxValue.id,
                'data_to': "999",
                'date_from': "2020-01-01",
                'date_to': "2099-12-31",
            }
            var newPromise = getReportData('cash-aux/by-date/', values).then(response => {
                // console.log(response.data)

                // Open PDF Here
                var file = new Blob([response.data], { type: 'application/pdf' });
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);

            })


        }
    }

    const classes = useStyles();

    return (
        <Paper className={classes.paper}>
            <CssBaseline />
            <ReportModal handleReportFormClose={handleReportFormClose} showReportForm={showReportForm} cashId={cashAuxValue ? cashAuxValue.id:0} permission={permission} />
            <GenericDialogBox
                opn={dialogOpen}
                handleDialogOk={handleDialogOk}
                handleDialogClose={handleDialogClose}
                title={dialogueTitle}
                body={dialogueBody} />
            <InfoBox
                opn={infoOpen}
                handleDialogClose={handleInfoClose}
                title={infoTitle}
                body={infoBody} />
            <Paper className={classes.paperHead}>
                <Grid container spacing={1}>
                    <Grid item xs={4}>
                        <Typography variant="h4" component="h4">
                            {t("cash_form_cash_aux_id")}: {cashAuxValue ? cashAuxValue.id : 0}
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Autocomplete
                            id="cash_aux_select"
                            // value={value}
                            options={cashAuxtData}
                            getOptionLabel={(option) => option.name ? option.name : "-"}
                            onChange={(event, newValue) => {
                                // console.log("new value", newValue)
                                if (!newValue) {
                                    cleanFields(newValue)
                                }
                                setCashAuxValue(newValue);
                            }}
                            inputValue={cashAuxInputValue}
                            onInputChange={(event, newInputValue) => {
                                // console.log("new input value", newInputValue)
                                setCashAuxInputValue(newInputValue);
                            }}

                            value={cashAuxValue ? cashAuxValue : ""}
                            renderInput={(params) => <TextField {...params} label={t("cash_form_lbl_cash_aux_select")} variant="outlined" />}
                            getOptionSelected={(option, value) => option.value === value.value}
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <Fab color="primary"
                            aria-label="add"
                            className={[classes.fab, classes.fabLeft]}
                            onClick={isAdding ? handleCreating : handleAdding}
                            disabled={!hasAddPerm ? true : isEditing} >
                            {isAdding ? <SaveIcon /> : <AddIcon />}
                        </Fab>
                    </Grid>
                    <Grid item xs={1}>
                        <Fab aria-label="edit"
                            className={[classes.fab, classes.fabEdit]}
                            disabled={!hasEditPerm ? true : isAdding}
                            onClick={isEditing ? handleUpdating : handleEditing}>
                            {isEditing ? <SaveIcon /> : <EditIcon />}
                        </Fab>
                    </Grid>
                    <Grid item xs={1}>
                        <Fab aria-label="delete"
                            className={[classes.fab, classes.fabDelete]}
                            disabled={!hasDeletePerm ? true : isEditing || isAdding ? true : false}
                            onClick={handleDeleting}>
                            <DeleteIcon />
                        </Fab>
                    </Grid>
                    <Grid item xs={1}>
                        <Fab aria-label="print" className={[classes.fab]}
                            disabled={!hasAddPerm ? true : isEditing || isAdding ? true : false}
                            onClick={handlePrinting}>
                            <PrintIcon />
                        </Fab>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputRef={cashAuxNameRef}
                            variant="outlined"
                            margin="normal"
                            size="small"
                            fullWidth
                            id="cash_name"
                            label={t("cash_form_lbl_cash_name")}
                            name="cash_name"
                            onChange={event => setCashNameValue(event.target.value)}
                            value={cashNameValue}
                            disabled={!isEditing && !isAdding}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            size="small"
                            id="cash_user"
                            label={t("cash_form_lbl_cash_user")}
                            name="cash_user"
                            // onChange={event => setCashUserValue(event.target.value)}
                            value={cashUserValue}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            size="small"
                            id="cash_description"
                            label={t("cash_form_lbl_cash_description")}
                            name="cash_description"
                            multiline
                            rows={2}
                            onChange={event => setCashDescriptionValue(event.target.value)}
                            value={cashDescriptionValue}
                            disabled={!isEditing && !isAdding}
                            style={{ marginTop: '-2px' }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            size="small"
                            id="date_created"
                            label={t("cash_form_lbl_cash_date_created")}
                            name="date_created"
                            // onChange={event => setFootNoteValue(event.target.value)}
                            value={cashDateCreatValue}
                            style={{ marginTop: '-2px' }}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            size="small"
                            id="date_updated"
                            label={t("cash_form_lbl_cash_date_modified")}
                            name="date_updated"
                            // onChange={event => setFootNoteValue(event.target.value)}
                            value={cashDateUpdateValue}
                            style={{ marginTop: '-2px' }}
                            disabled={true}
                        />
                    </Grid>
                </Grid>
            </Paper>
            <CashAuxTable cashId={cashAuxValue ? cashAuxValue.id : null}
                buttonDisabled={cashAuxValue ? false : true}
            />
        </Paper>
    )
})

export default CashForm;
